import React, { FunctionComponent, useEffect, useRef, useState, } from "react";
import { connect, useDispatch } from "react-redux";
// import { showSnackbarAction } from "../../../Redux/actions";
// import styles from "../../BulkEditModal/BulkEditModal.module.css";
import styles from "./CallRecordingDescriptionModal.module.css";
// import "../../../Screens/AuditLogs/AuditLog.css";
// import Loading from "../../../Components/Loading/Loading";
// import Backdrop from "../../../Components/Backdrop/Backdrop";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosClose } from "react-icons/io";
// import Label from "../../../Components/Label";
// import TextInput from "../../../Components/TextInput/TextInput";
import { themeColors } from "../../../Components/theme";
// import axios from "axios";
// import { url } from "../../../Values/constants";
// import axiosHandler from "../../../Services/axiosHandler";
// import { setUser } from "../../../Redux/actions";

type props = {
    close: () => void;
    open: boolean;
    theme?: any;
    user?: any;
};

const slideInFromRight = {
    hidden: {
        translateX: "0%", // Move off-screen to the right, without affecting layout
        opacity: 0,
    },
    visible: {
        translateX: "0%", // Bring into view
        opacity: 1,
        transition: {
            duration: 0.25,
            ease: "linear",
        },
    },
    exit: {
        translateX: "0%", // Slide out without triggering horizontal scrollbars
        opacity: 0,
        transition: {
            duration: 0.25,
            ease: "linear",
        },
    },
};




const CallRecordingDescriptionModal: FunctionComponent<props> = ({
    close,
    open,
    theme,
    user,
}) => {
    // const [isDeclarationChecked, setIsDeclarationChecked] = useState(false);
    // const [newMobileNumber, setNewMobileNumber] = useState("");

    // const dispatcher = useDispatch();

    const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark };

    return (
        <>
            {/* {load === true && <Loading />} */}
            <AnimatePresence>
                {open &&
                    // <Backdrop>
                    <motion.div
                        key="modal"
                        className="px-4 py-3 shadow"
                        style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: "30vw",
                            height: "100vh",
                            display: "flex",
                            flexDirection: "column",
                            boxShadow: "0 3px 11px 0 rgba(0, 0, 0, 0.2)",
                            zIndex: 1000,
                            overflowX: "hidden",
                            // justifyContent: "center",
                            // alignItems: "center",
                            ...containerStyles
                        }}
                        variants={slideInFromRight}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                    >
                        <div className={styles.cross} onClick={close}>
                            <IoIosClose size={35} color={"#808080"} />
                        </div>
                        <p className={styles.title}>What is <span className={styles.titleBold}>Call Recordings?</span></p>
                        <p className={styles.callRecordingDescription}>ReadPro can automatically sync call recordings for your calls. ReadPro works on Android phones which support call recording by default. After each call ReadPro will access the recording folder of the device and try to sync the file.</p>

                        <p className={styles.callRecordingDescription}>However, some phones do not have inbuilt call recording, and some phones which have it may not make the folder available to other apps
                            (Such as some MI phones), in these cases we cannot sync the recordings.</p>

                        <p className={styles.callRecordingDescription}>If you think you have a phone where recording works and the files are accessible from the file manager, yet ReadPro does not sync it, kindly contact your account manager with your device details and the path to recording.
                             {/* <span className={styles.mailLink}><a className={styles.mailLink} href="mailto:support@magicbricks.com">support@magicbricks.com</a></span> */}
                             </p>

                        <p className={styles.callRecordingDescription}>Please enable recording here and also at agent's setting page to ensure call recordings are enabled.</p>
                    </motion.div>
                    // </Backdrop>
                }
            </AnimatePresence>
        </>
    );
};

const mapStateToProps = (state: any) => {
    return {
        theme: state.theme.isLightMode,
        user: state.user.data,
    };
};

export default connect(mapStateToProps)(CallRecordingDescriptionModal);